/* The mark and wordmark every shareable overlay signs off with, and the PNG
   handoff they all end on. Shared by the walk and the duel exports so the two
   sign off identically. */

export const OVERLAY_FONT_FAMILY = "'Hanken Grotesk', sans-serif";
export const OVERLAY_LOGO_HEIGHT = 72;
export const OVERLAY_WORDMARK_HEIGHT = 34;

/* Inlined from ui/images/logo-mark.svg so the render stays synchronous — an
   <img> load could resolve after the export has already been handed off. The
   crown is drawn flush to its box, so OVERLAY_LOGO_HEIGHT is the height callers
   actually advance their cursor by, and it comes out about 153px wide on the
   1080 canvas. The subpaths are disjoint, so the default nonzero fill applies. */
const LOGO_INK = { x: 0, y: 0, width: 66.1832, height: 31.2169 };
const LOGO_PATH = [
  'M0.00123492 6.66539C1.84183 6.66539 3.33393 5.17329 3.33393 3.3327C3.33393 1.4921 1.84183 0 0.00123492 0V6.66539Z',
  'M0.00123492 27.2169V11.9421H3.47201C3.47201 19.1357 9.29199 24.9702 16.4797 24.9951H16.5224C23.6791 24.9703 29.479 19.1859 29.5289 12.0351V11.9421H36.472C36.472 19.1357 42.292 24.9702 49.4797 24.9951H49.5224C56.6791 24.9703 62.479 19.1859 62.5289 12.0351V11.9421H66.1832V27.2169H0.00123492Z',
  'M66.0012 6.66539C66.0623 6.66539 66.1229 6.66375 66.1832 6.66051V0.00488281C66.1229 0.00164175 66.0623 0 66.0012 0C64.1606 0 62.6685 1.4921 62.6685 3.3327C62.6685 5.17329 64.1606 6.66539 66.0012 6.66539Z',
  'M33.0012 0C31.1606 0 29.6685 1.4921 29.6685 3.3327C29.6685 5.17329 31.1606 6.66539 33.0012 6.66539C34.8418 6.66539 36.3339 5.17329 36.3339 3.3327C36.3339 1.4921 34.8418 0 33.0012 0Z',
  'M66.1832 30.2014L0 30.2014V31.2169L66.1832 31.2169V30.2014Z',
].join('');
const WORDMARK = 'GAMBITS.COM';

export function drawOverlayLogo(ctx: CanvasRenderingContext2D, centerX: number, top: number): void {
  const scale = OVERLAY_LOGO_HEIGHT / LOGO_INK.height;
  const left = centerX - (LOGO_INK.width * scale) / 2;

  ctx.save();
  ctx.translate(left, top);
  ctx.scale(scale, scale);
  ctx.translate(-LOGO_INK.x, -LOGO_INK.y);
  ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
  ctx.fill(new Path2D(LOGO_PATH));
  ctx.restore();
}

export function drawOverlayWordmark(ctx: CanvasRenderingContext2D, centerX: number, top: number): void {
  ctx.fillStyle = '#ffffff';
  ctx.font = `900 30px ${OVERLAY_FONT_FAMILY}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  /* Set after `font`, which resets tracking in some engines. Safari below 17
     ignores it entirely and renders the wordmark untracked. */
  const tracked = ctx as CanvasRenderingContext2D & { letterSpacing?: string };
  const previousSpacing = tracked.letterSpacing;
  tracked.letterSpacing = '5px';

  ctx.fillText(WORDMARK, centerX, top + OVERLAY_WORDMARK_HEIGHT / 2);

  tracked.letterSpacing = previousSpacing ?? '0px';
}

export function canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob | null> {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), 'image/png');
  });
}
